module.exports = __webpack_public_path__ + "img/IND-A-2-II.d7ccf47f.png";